export const logout = () => {
	return window.location.reload()
}